import React from 'react';
import { useNavigate } from '@remix-run/react';
import { SearchSuggestionList } from '@rocco/ui/search/components/SearchSuggestionList';
import type {
    SearchSuggestion,
    SearchSuggestionGroup,
} from '@rocco/ui/search/view-models/search-suggestion';
import { isCategorySuggestion } from '@rocco/ui/search/utils/type-guards';
import { generateURL } from '@modules-rocco/url/api/generate-url';

interface MobileSearchPageSuggestedGroupsProps {
    query: string;
    group: SearchSuggestionGroup;
}

/**
 * Renders a list of search suggestions grouped by type (e.g., keywords, categories) for mobile view.
 * Handles navigation when a suggestion is clicked.
 */
export const MobileSearchPageSuggestedGroups: React.FC<
    MobileSearchPageSuggestedGroupsProps
> = ({ query, group }) => {
    const navigate = useNavigate();

    const onSearchSuggestionClick = (suggestion: SearchSuggestion | string) => {
        if (isCategorySuggestion(suggestion)) {
            // TODO: Add tracking here if needed
            navigate(suggestion.link);
        } else {
            // TODO: Add tracking here if needed
            navigate(
                generateURL('/search', {
                    search: suggestion,
                })
            );
        }
    };

    return (
        <div className="px-6 md:px-0">
            <SearchSuggestionList
                group={group}
                query={query}
                onOptionClick={(suggestion) =>
                    onSearchSuggestionClick(suggestion)
                }
            />
        </div>
    );
};
